import { render, staticRenderFns } from "./PayOrderDetails.vue?vue&type=template&id=6fa1947a&"
import script from "./PayOrderDetails.vue?vue&type=script&lang=js&"
export * from "./PayOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./PayOrderDetails.vue?vue&type=style&index=0&id=6fa1947a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports